import { AdditionalService } from '@cemex-core/cmx-api';
import {
  OneClickAdditionalServicesActions,
  OneClickAdditionalServicesActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-additional-services.actions';

export interface OneClickAdditionalServicesState {
  loading: boolean;
  additionalServicesAvailable: AdditionalService[];
  selected: AdditionalService;
}

export const initialState: OneClickAdditionalServicesState = {
  loading: false,
  additionalServicesAvailable: [],
  selected: null,
};

export function reducer(
  state = initialState,
  action: OneClickAdditionalServicesActions,
): OneClickAdditionalServicesState {
  switch (action.type) {
    case OneClickAdditionalServicesActionTypes.LOAD_ADITIONAL_SERVICES: {
      return {
        ...state,
        loading: true,
      } as OneClickAdditionalServicesState;
    }
    case OneClickAdditionalServicesActionTypes.LOAD_ADITIONAL_SERVICES_COMPLETE: {
      return {
        ...state,
        loading: false,
        additionalServicesAvailable: [...action.payload],
      } as OneClickAdditionalServicesState;
    }
    case OneClickAdditionalServicesActionTypes.SELECT_ADITIONAL_SERVICES: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickAdditionalServicesState;
    }
    case OneClickAdditionalServicesActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
